<template>
    <div id="new-whitelist">
        <div class="breadcrumb">
            <span>清场白名单 > 新增</span>
            <el-button class="right_f" type="primary" @click="cancel">取消</el-button>
            <el-button class="right_f" type="primary" @click="save">保存</el-button>
        </div>
        <div class="whitelist-content">
            <el-form ref="clearanceForm" :rules="rules" :model="clearanceForm" label-width="150px">
                <el-form-item class="white-form" label="类型：" prop="type" style="margin-bottom: 18px;" required>
                    <el-select v-model="clearanceForm.type">
                        <el-option label="模拟app" value="1"></el-option>
                        <el-option label="中病毒" value="2"></el-option>
                        <el-option label="运行在虚拟环境" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="white-form" label="手机号：" prop="phoneNumber" style="margin-bottom: 18px;" required>
                    <el-input v-model="clearanceForm.phoneNumber" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="手机imei：" prop="imei" style="margin-bottom: 18px;" required>
                    <el-input v-model="clearanceForm.imei" placeholder="请输入手机imei"></el-input>
                </el-form-item>
                <el-form-item label="手机型号：" prop="phoneModel" style="margin-bottom: 18px;" required>
                    <el-input v-model="clearanceForm.phoneModel" placeholder="请输入手机型号"></el-input>
                </el-form-item>
                <el-form-item label="系统版本：" prop="systemVersion" style="margin-bottom: 18px;" required>
                    <el-input v-model="clearanceForm.systemVersion" placeholder="请输入系统版本"></el-input>
                </el-form-item>
                <el-form-item label="是否root：" prop="root" class="wxApp-from" required>
                    <el-radio v-model="clearanceForm.root" label="1">是</el-radio>
                    <el-radio v-model="clearanceForm.root" label="0">否</el-radio>
                </el-form-item>
                <el-form-item label="图片：" class="right" prop="imageUrl" required>
                    <el-upload :action="actionUrl" :with-credentials='true' accept="image/*" name="uploadFile"
                        type="drag" class="upload-demo" :thumbnail-mode="true" :on-error="handleError"
                        :on-success="handleSuccess">
                        <i class="el-icon-upload"></i>
                        <div class="el-dragger__text">将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import { mapActions } from 'vuex'
    export default {
        data() {
            let checkPhoneNumber = (rule, value, callback) => {
                if (value) {
                    let str = /^1[3456789]\d{9}$/;
                    if (str.test(value)) {
                        callback();
                    } else {
                        callback(new Error("手机号输入有误"));
                    }
                } else {
                    callback(new Error("手机号不能为空"));
                }
            };

            return {
                actionUrl: this.$util.domain + '/adminapi/v1/basicTools/upload/one?uploadImageType=11',
                clearanceForm: {
                    type: '',
                    phoneNumber: '',
                    imei: "",
                    phoneModel: "",
                    root: '1',
                    systemVersion: "",
                    imageUrl: ""
                },
                rules: {
                    type: [{ required: true, message: "请选择类型", trigger: "change" }],
                    imei: [{ required: true, message: "手机imei不能为空", trigger: "blur" }],
                    phoneModel: [{ required: true, message: "手机型号不能为空", trigger: "blur" }],
                    systemVersion: [{ required: true, message: "系统版本不能为空", trigger: "blur" }],
                    imageUrl: [{ required: true, message: "请上传图片", trigger: "blur" }],
                    phoneNumber: [
                        { message: "手机号不能为空", trigger: "blur" },
                        { validator: checkPhoneNumber }
                    ]
                }
            }
        },
        mounted() {

        },
        methods: {
            ...mapActions(['SIGNOUT']),
            save() {
                let url = this.$util.domain + '/adminapi/v1/whiteList/add';
                this.$refs.clearanceForm.validate(valid => {
                    if (valid) {
                        let requestBody = {
                            phoneNumber: this.clearanceForm.phoneNumber,
                            imei: this.clearanceForm.imei,
                            phoneModel: this.clearanceForm.phoneModel,
                            root: this.clearanceForm.root == 1 ? true : false,
                            systemVersion: this.clearanceForm.systemVersion,
                            imageUrl: this.clearanceForm.imageUrl,
                            type: this.clearanceForm.type
                        };

                        this.$http({
                            url: url,
                            method: "POST",
                            body: JSON.stringify(requestBody)
                        }).then(response => {
                            if (response.data.error === 10000) {
                                location.href = "/#/whitelist/clearWhiteList";
                            } else {
                                this.$util.errorMsg(response.data.message);
                            }
                        })
                    }
                })
            },
            cancel() {
                location.href = '/#/whitelist/clearWhiteList';
            },
            handleSuccess(response) {
                if (response.error !== 10000) {
                    this.$util.errorMsg("上传失败");
                } else {
                    this.clearanceForm.imageUrl = response.data;
                }
            },
            handleError(response) {
                if (response.status === 403) {
                    this.SIGNOUT();
                    location.href = "/#";
                }
                this.$util.errorMsg("上传失败");
            }
        }
    }
</script>
<style scoped>
    .whitelist-content {
        width: 520px;
    }
</style>


// WEBPACK FOOTER //
// newWhiteList.vue?7a01c87b